import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./variables.css";
import "./index.css";
import "./tailwindstyles.css";

import App from "./App";
import "./i18n/i18n";
import posthog from "posthog-js";

import { readBooleanEnv } from "./configs/featureFlags";
import { getRuntimeEnv } from "./configs/runtimeConfig";
import { initTelemetry } from "./telemetry";

initTelemetry().catch((error) => {
  console.error("[telemetry] initialization failed", error);
});

const sentryEnabled = readBooleanEnv(
  getRuntimeEnv("REACT_APP_SENTRY_ENABLED"),
  process.env.NODE_ENV !== "development",
);
const sentryDsn = getRuntimeEnv("REACT_APP_SENTRY_DSN");

if (sentryEnabled && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: false,
    environment:
      getRuntimeEnv("REACT_APP_SENTRY_ENVIRONMENT") ||
      getRuntimeEnv("REACT_APP_OTEL_ENV") ||
      getRuntimeEnv("REACT_APP_ENV") ||
      process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    beforeSend(event) {
      const breadcrumbs = event.breadcrumbs?.values ?? [];
      const hasFedCmOptOut = breadcrumbs.some(
        (b) =>
          b.data?.url?.includes("has_opted_out_fedcm=true") ||
          b.message?.includes("has_opted_out_fedcm"),
      );
      if (hasFedCmOptOut) return null;
      return event;
    },
  });
}

const posthogKey = getRuntimeEnv("REACT_APP_POSTHOG_KEY");
const posthogHost =
  getRuntimeEnv("REACT_APP_POSTHOG_HOST") || "https://us.i.posthog.com";

if (posthogKey && process.env.NODE_ENV !== "development") {
  posthog.init(posthogKey, {
    api_host: posthogHost,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Suspense fallback="...loading">
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Suspense>,
);
